<div class="w-full mx-auto mt-8 rounded-lg max-h-[90vh] flex flex-col">

  <div class="py-2 px-4 border-gray-300 flex-shrink-0">
    @if (formation === null || formation.id === 0 || formation.id === undefined) {
      <p class="titre2">
        {{ 'GROUP_TRAINING_MANAGEMENT.CREATE_GROUP_TRAINING' | translate }}
      </p>
    }
    @if (formation !== null && formation.id > 0 && formation.id !== undefined) {
      <p class="titre2">
        {{ 'GROUP_TRAINING_MANAGEMENT.MODIFY_GROUP_TRAINING' | translate }}
      </p>
    }
  </div>

  @if (isLoading) {
    <div class="flex justify-center items-center h-64">
      <mat-spinner color="accent"></mat-spinner>
    </div>
  }

  @if (!isLoading) {
    <form (ngSubmit)="saveTraining()" class="flex flex-col flex-1 min-h-0">
      <div class="flex-1 overflow-y-auto p-4">
        <div class="grid grid-cols-3 gap-4">
          <div class="mb-4">
            <label for="titre" class="block text-sm font-medium mb-1">
              {{ 'GROUP_TRAINING_MANAGEMENT.TITRE' | translate }}<span class="text-red-500">*</span>
            </label>
            <input type="text" id="titre" [(ngModel)]="formation.titre" name="titre" required
              class="mt-1 block w-full rounded-md border-gray-300">
            </div>
            <div class="mb-4">
              <label for="emplacement" class="block text-sm font-medium mb-1">
                {{ 'GROUP_TRAINING_MANAGEMENT.EMPLACEMENT' | translate }} <span class="text-red-500">*</span>
              </label>
              <input type="text" id="emplacement" [(ngModel)]="formation.emplacement" name="emplacement" required
                class="mt-1 block w-full rounded-md border-gray-300">
              </div>
              <div class="mb-4">
                <label for="datePrevue" class="block text-sm font-medium mb-1">
                  {{ 'GROUP_TRAINING_MANAGEMENT.DATE_PREVUE' | translate }} <span class="text-red-500">*</span>
                </label>
                <input type="datetime-local" step="300" id="datePrevue" [(ngModel)]="formation.dateHeurePrevue"
                  name="datePrevue" required class="mt-1 block w-full rounded-md border-gray-300" />
                </div>
              </div>
              <div class="grid grid-cols-[2fr_1fr] gap-3 mb-4">
                <div class="flex flex-col">
                  <label for="formation">
                    {{ 'GROUP_TRAINING_MANAGEMENT.FLITRE_FORMATION' | translate }}
                    <span class="text-red-500">*</span>
                    @if (afficherMentionLegale) {
                      <span class="ms-2 italic text-red-500 text-[18px]">
                        {{'GROUP_TRAINING_MANAGEMENT.MENTION_OBLIGATION_LEGALE' | translate }}
                        <span class="text-red-500">*</span>
                      </span>
                    }
                  </label>
                  <mat-select id="formation" (selectionChange)="onSelectionChangeScormPackage($event)"
                    placeholder="{{ 'GROUP_TRAINING_MANAGEMENT.FLITRE_FORMATION' | translate }}"
                    class="w-full border border-gray-300 rounded-md px-3 py-1 mb-4" [value]="formation.packageId">
                    <mat-option>
                      <ngx-mat-select-search [formControl]="scormPackagesFilterCtrl"
                        [placeholderLabel]="'GROUP_TRAINING_MANAGEMENT.SEARCH_FORMATION' | translate"
                        [noEntriesFoundLabel]="'GROUP_TRAINING_MANAGEMENT.NO_RESULTS' | translate">
                      </ngx-mat-select-search>
                    </mat-option>
                    @for (scormPackage of filteredscormPackages | async; track scormPackage) {
                      <mat-option class="border-b border-gray-400"
                        [value]="scormPackage.scormPackageId">
                        <span class="inline-block text-sm">{{ getLocalizedContent(scormPackage.scormPackageId).titre }}</span>
                        @if (getDureeEnMinutes(scormPackage.scormPackageId)) {
                          <span class="inline-block text-xs text-gray-500 ml-2">
                            ({{ getDureeEnMinutes(scormPackage.scormPackageId) }} {{ 'SCORMS_LIST.MINUTES' | translate }})
                          </span>
                        }
                      </mat-option>
                    }
                  </mat-select>
                  <div>
                    <label for="commentaire" class="block text-sm font-medium mb-1">
                      {{ 'GROUP_TRAINING_MANAGEMENT.COMMENTAIRE' | translate }}:
                    </label>
                    <textarea maxlength="200" placeholder="{{ 'GROUP_TRAINING_MANAGEMENT.MAX_CHARS' | translate }}" type="text"
                      id="commentaire" [(ngModel)]="formation.commentaire" name="commentaire" required
                    class="block w-full rounded-md border-gray-300 h-32"></textarea>
                  </div>
                </div>
                <div class="flex flex-col items-center">
                  <div class="max-h-[220px] mt-3 overflow-y-auto">
                    @if (formation.packageId > 0) {
                      <div class="w-full">
                        @if (estPasAutoriserEnFormationGroupe) {
                          <span class="text-center italic text-red-500 text-2xl">
                            {{ 'GROUP_TRAINING_MANAGEMENT.MESSAGE_NON_AUTORISE' | translate }}
                          </span>
                        }
                        @if (!estPasAutoriserEnFormationGroupe) {
                          <a class="block rounded-3xl">
                            <div class="bg-black h-[220px] rounded-3xl">
                              <img title="img" [src]="getLocalizedContent(formation.packageId).thumbnail"
                                [alt]="getLocalizedContent(formation.packageId).titre + ' thumbnail'"
                                class="w-full h-full object-cover rounded-3xl" />
                              </div>
                            </a>
                            @if (getDureeEnMinutes(formation.packageId)) {
                              <div class="flex items-center gap-1 mt-2 text-sm">
                                <span class="material-symbols-outlined text-[15px]">timer</span>
                                <span>{{ 'GROUP_TRAINING_MANAGEMENT.DUREE_ESTIMEE' | translate }} :
                                  {{ getDureeEnMinutes(formation.packageId) }} {{ 'SCORMS_LIST.MINUTES' | translate }}</span>
                              </div>
                            }
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <div class="grid grid-cols-3 gap-3 mb-4">
                  <div class="flex flex-col">
                    <label for="superviseurs">
                      {{ 'GROUP_TRAINING_MANAGEMENT.FLITRE_SUPERVISEURS' | translate }}<span class="text-red-500">*</span>
                    </label>
                    <mat-select id="superviseurs" #superviseurSelect (selectionChange)="onSelectionChangeSuperviseur($event)"
                      placeholder="{{ 'GROUP_TRAINING_MANAGEMENT.FLITRE_SUPERVISEURS' | translate }}"
                      class="w-full border border-gray-300 rounded-md px-3 py-1 text-white">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="superviseurFilterCtrl"
                          [placeholderLabel]="'GROUP_TRAINING_MANAGEMENT.SEARCH_USER' | translate"
                          [noEntriesFoundLabel]="'GROUP_TRAINING_MANAGEMENT.NO_RESULTS' | translate">
                        </ngx-mat-select-search>
                      </mat-option>
                      @for (superviseur of filteredSuperviseurs | async; track superviseur) {
                        <mat-option [value]="superviseur.utilisateurId">
                          <span class="inline-block whitespace-nowrap text-sm">{{ superviseur.prenom }} {{ superviseur.nom }}</span>
                        </mat-option>
                      }
                    </mat-select>
                  </div>
                  <div class="flex flex-col">
                    <label for="etiquettes">{{ 'GROUP_TRAINING_MANAGEMENT.FILTRE_ETIQUETTES' | translate }}</label>
                    <mat-select id="etiquettes" #etiquetteSelect (selectionChange)="onSelectionChangeEtiquettes($event)"
                      placeholder="{{ 'GROUP_TRAINING_MANAGEMENT.FILTRE_ETIQUETTES' | translate }}"
                      class="w-full border border-gray-300 rounded-md px-3 py-1 text-white">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="etiquetteFilterCtrl"
                          [placeholderLabel]="'GROUP_TRAINING_MANAGEMENT.SEARCH_USER' | translate"
                          [noEntriesFoundLabel]="'GROUP_TRAINING_MANAGEMENT.NO_RESULTS' | translate">
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option [value]="-1">
                        <span class="inline-block whitespace-nowrap text-sm">
                          {{ 'GROUP_TRAINING_MANAGEMENT.SELECT_ALL_ETIQUETTES' | translate }}
                        </span>
                      </mat-option>
                      @for (etiquette of filteredEtiquettes | async; track etiquette) {
                        <mat-option [value]="etiquette.etiquetteId">
                          <span class="inline-block whitespace-nowrap text-sm">
                            {{etiquetteService.getNomLocalise(etiquette.locales)}}
                          </span>
                        </mat-option>
                      }
                    </mat-select>
                  </div>
                  <div class="flex flex-col">
                    <label for="participants">
                      {{ 'GROUP_TRAINING_MANAGEMENT.FLITRE_PARTICIPANTS' | translate }}<span class="text-red-500">*</span>
                    </label>
                    <mat-select id="participants" #participantSelect (selectionChange)="onSelectionParticipantChange($event)"
                      placeholder="{{ 'GROUP_TRAINING_MANAGEMENT.FLITRE_PARTICIPANTS' | translate }}"
                      class="w-full border border-gray-300 rounded-md px-3 py-1 text-white">
                      <mat-option>
                        <ngx-mat-select-search [formControl]="participantFilterCtrl"
                          [placeholderLabel]="'GROUP_TRAINING_MANAGEMENT.SEARCH_PARTICIPANT' | translate"
                          [noEntriesFoundLabel]="'GROUP_TRAINING_MANAGEMENT.NO_RESULTS' | translate">
                        </ngx-mat-select-search>
                      </mat-option>
                      <mat-option #optionSelect [value]="-1" (click)="selectAllParticipants()">
                        {{ 'GROUP_TRAINING_MANAGEMENT.SELECT_ALL' | translate }}
                      </mat-option>
                      @for (participant of filteredParticipants | async; track participant) {
                        <mat-option class="ml-2"
                          [value]="participant.utilisateurId">
                          <span class="inline-block whitespace-nowrap text-sm">{{ participant.prenom }} {{ participant.nom }}</span>
                        </mat-option>
                      }
                    </mat-select>
                  </div>
                </div>
                <table class="table-fixed w-full">
                  <colgroup>
                  <col class="w-1/3">
                  <col class="w-1/3">
                  <col class="w-1/3">
                </colgroup>
                <tr class="align-top">
                  <td class="p-0">
                    <div class="max-h-[200px] overflow-y-auto">
                      <ul class="list-disc list-inside mr-2 ml-0 p-0">
                        @for (utilisateur of selectedSuperviseurs; track utilisateur) {
                          <li
                            class="flex items-center p-2 bg-gray-50 h-8 rounded-md text-gray-600 justify-between my-1">
                            <span>{{ utilisateur.prenom }} {{ utilisateur.nom }}</span>
                            <button (click)="removeSupervisor(utilisateur.utilisateurId)"
                              class="px-2 py-1 text-sm text-red-500 hover:text-red-700">
                              <mat-icon>close</mat-icon>
                            </button>
                          </li>
                        }
                      </ul>
                    </div>
                  </td>
                  <td class="p-0">
                    <div class="max-h-[200px] overflow-y-auto">
                      <ul class="list-disc list-inside mr-2 ml-1 p-1">
                        @for (etiquette of selectedEtiquettes; track etiquette) {
                          <li
                            class="flex items-center p-2 bg-gray-50 h-8 rounded-md text-gray-600 justify-between my-1">
                            <span>{{ etiquetteService.getNomLocalise(etiquette.locales) }}</span>
                            <button (click)="removeEtiquette(etiquette.etiquetteId)"
                              class="px-2 py-1 text-sm text-red-500 hover:text-red-700">
                              <mat-icon>close</mat-icon>
                            </button>
                          </li>
                        }
                      </ul>
                    </div>
                  </td>
                  <td class="p-0">
                    <div class="max-h-[200px] overflow-y-auto">
                      @if (selectedParticipants.length > 10) {
                        <div class="flex justify-between gap-2 mr-3">
                          <span class="btn-primary-novo btn-icon-delete max-w-[75px] h-8 mt-2 mb-2 material-symbols-outlined"
                          (click)="viderParticipants()">clear_all</span>
                          <input type="text" class="w-full h-8 mt-2 border border-gray-300 rounded-md px-3 py-1"
                            (keyup)="filtreSelectedParticipants($event)"
                            placeholder="{{ 'GROUP_TRAINING_MANAGEMENT.SEARCH' | translate }}">
                          </div>
                        }
                        <ul class="list-disc list-inside mr-2 ml-1 p-1">
                          @for (utilisateur of selectionParticipantFiltreEncours; track utilisateur) {
                            <li
                              class="flex items-center p-2 bg-gray-50 h-8 rounded-md text-gray-600 justify-between my-1">
                              <span>{{ utilisateur.prenom }} {{ utilisateur.nom }}</span>
                              @if (utilisateur !== null) {
                                <button (click)="removeParticipant(utilisateur.utilisateurId)"
                                  class="px-2 py-1 text-sm text-red-500 hover:text-red-700">
                                  <mat-icon>close</mat-icon>
                                </button>
                              }
                            </li>
                          }
                        </ul>
                      </div>
                    </td>
                  </tr>
                </table>
                <div class="mt-4 mb-4 p-4 border border-gray-300 rounded-md bg-gray-50">
                  <div class="flex items-start">
                    <input type="checkbox" id="consentement-checkbox"
                      class="form-checkbox h-4 w-4 transition duration-150 ease-in-out mt-1 mr-3 rounded-sm flex-shrink-0"
                      [(ngModel)]="consentementConfirme" name="consentementConfirme" />
                      <label for="consentement-checkbox" class="text-sm text-white cursor-pointer">
                        <div>{{ 'GROUP_TRAINING_MANAGEMENT.CONSENT_TEXT_1' | translate }}</div>
                        <div class="mt-3">{{ 'GROUP_TRAINING_MANAGEMENT.CONSENT_TEXT_2' | translate }}</div>
                        <div class="mt-3">
                          {{ 'GROUP_TRAINING_MANAGEMENT.CONSENT_TEXT_3' | translate }}<span class="text-red-500">*</span>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="py-2 px-4 border-t border-gray-300 flex-shrink-0 flex justify-end gap-6">
                  <button type="button" (click)="closeDialog()" class="btn-secondary-novo">
                    {{ 'GROUP_TRAINING_MANAGEMENT.CANCEL' | translate }}
                  </button>
                  <button type="submit" [disabled]="boutonSauvegardeDesactive()"
                    class="btn-primary-novo focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed">
                    {{ 'GROUP_TRAINING_MANAGEMENT.SAVE' | translate }}
                  </button>
                </div>
              </form>
            }
          </div>
